import React from "react";
import Seo from "cube-components/Seo";
import PageLayout from "cube-components/PageLayout";
import { StaticImage } from "gatsby-plugin-image";

const meta = {
    title: "About Us | Lucid Modules",
    description:
        "Learn about the story behind Lucid Modules and its founder. Magento 2 and WEB 3D agency in Taiwan."
};

const About = () => {
    return (
        <PageLayout>
            <section className="relative border-t border-lucid-800">
                <div className="relative max-w-6xl mx-auto px-4 sm:px-6">
                    <div className="pt-32 md:pt-40 text-center md:text-start">
                        <div className="max-w-3xl mx-auto">
                            <div
                                className="h-lvh md:h-fit max-w-3xl mx-auto bg-gradient-to-b from-transparent to-accent-400 md:bg-none">
                                <h1 className="h1 font-hkgrotesk mb-1 text-4xl md:text-5xl">
                                    About Lucid Modules
                                </h1>
                                <p className="text-lg text-lucid-300 mb-10">
                                    Read the story behind Lucid Modules - an innovative Magento agency in Taiwan.
                                </p>
                            </div>

                            <div className="flex flex-col md:flex-row justify-center items-center py-5 md:py-20">
                                <div>
                                    <h3 className="h1 font-hkgrotesk mb-2 md:mb-6 text-3xl md:text-6xl">Hello, I'm
                                        Matt</h3>
                                    <p className="text-2xl text-lucid-300">The founder of Lucid Modules</p>
                                </div>
                                <figure className="mx-auto pt-10 pb-20 text-center">
                                    <StaticImage src="../images/about/matt-chad-blue.jpg"
                                                 alt="Matt Chad - Founder of Lucid Modules"
                                                 className="mx-auto mt-3 mb-1 rounded-3xl"
                                                 width={300}
                                                 transformOptions={{fit: "contain", cropFocus: "attention"}}
                                    />
                                </figure>
                            </div>

                            <div className="blogpost-content text-start">
                                <p>
                                    There are moments in life when we come across our own Personal Black Swans.
                                    An unpredictable event or meeting a person with contrasting perspectives that
                                    significantly influences our worldview.
                                </p>
                                <p>
                                    We come across them when we least expect them, but in retrospect the meeting seems
                                    too obvious.
                                </p>
                                <p>
                                    Whatever the setting may be, these encounters
                                    leave an indelible
                                    mark on our mind, altering the way we perceive life itself.
                                </p>
                                <blockquote>
                                    I like black swans.
                                </blockquote>
                                <p>
                                    Many black swans dwell in Taiwan.
                                    Formosa, a beautiful island, was the first inspiration that sparked the idea to
                                    start Lucid Modules.
                                    The island’s unique environment blending natural beauty and technological innovation
                                    serves as a fertile ground for remarkable solutions.
                                </p>

                                <p>
                                    Innovation thrives here nurtured by openness and mutual respect.
                                    The welcoming nature of people living in Taiwan led to the creation of various ideas
                                    hub where concepts from all around the globe can be freely exchanged.
                                </p>

                                <p>
                                    The second reason:
                                    initially, I worked as Magento 2 developer and later as a Tech Lead. I spent my
                                    early professional
                                    career dedicated to building ecommerce solutions for international enterprises.
                                    Among them
                                    are TME, MODIVO
                                    (formerly Eobuwie) in Poland and Romanian Cora.
                               </p>
                               <p>
                                    If you'd like to learn more about my
                                    professional
                                    journey,
                                    please check out <a href="https://www.linkedin.com/in/matt-chad-22736a132/"
                                                        title="Matt Chad's LinkedIn profile">my LinkedIn
                                    profile</a>.
                                </p>

                                <p>
                                    While working in a corporate hierarchy, I realized it lacks the freedom necessary to
                                    create the best
                                    work. It is not an environment suitable for the Renaissance man or woman.
                                </p>

                                <p>
                                    Majority of the corporations avoid novelty and experimentation.
                                </p>

                                <p>
                                    However, the future belongs to agile companies.
                                </p>

                                <p>
                                    Similar to the prehistoric era, where the smaller mammals replaced the magnificent
                                    dinosaurs.
                                    Following
                                    the Agile does not equal with true agility.
                                </p>
                                <p>
                                    The ongoing advancements of AI will only speed up this change.
                                </p>

                                <p>
                                    The third reason follows the thought of Czech entrepreneur Tomáš Baťa, who claimed:
                                </p>
                                <blockquote>
                                    People should think and machines do the labor.
                                </blockquote>

                                <p>
                                    It is common for companies to have a postindustrial attitude and force employees to
                                    sit for long hours
                                    in front of computer screens. However, this approach is counterproductive in the
                                    long run.
                                </p>

                                <p>
                                    I believe that empowering individuals to think critically and harnessing the
                                    potential of technology
                                    to
                                    handle repetitive tasks leads to more efficient and innovative workplaces.
                                </p>

                                <p>
                                    Trust is the most valuable currency.
                                </p>

                                <p>
                                    An environment that fosters employee autonomy and responsibility has a significant
                                    impact on
                                    motivation
                                    and creativity levels. This leads to the development of high-quality products and
                                    solutions.
                                </p>

                                <h3>LUCID Manifesto</h3>
                                <p>
                                    Here is the explanation of LUCID approach:
                                </p>
                                <h4>
                                    Lightweight
                                </h4>
                                <p>
                                    Tradeoffs are an inevitable part of engineering. Both physical and virtual
                                    solutions adhere to 3 constraints: time, speed, and cost.

                                    The whole construction is as strong as its weakest link.
                                </p>
                                How to maintain lightweight solutions:
                                <ul>
                                    <li>
                                        Keep in mind the hierarchy of latencies:
                                        <ol>
                                            <li>
                                                Network
                                            </li>
                                            <li>
                                                Local Services
                                            </li>
                                            <li>
                                                Disk
                                            </li>
                                            <li>
                                                Ram
                                            </li>
                                            <li>
                                                CPU Cache
                                            </li>
                                        </ol>
                                    </li>
                                    <li>
                                        Never create god-objects, functions, modules which know too much beyond their
                                        context and are too
                                        expensive to replace.
                                    </li>
                                </ul>
                                <h4>
                                    User-centric
                                </h4>
                                <p>
                                    Even when a piece of software merely connects machines (API), we should remember
                                    about the user that
                                    sits at the end of the chain.
                                    Thus, launching a new piece of software must be straightforward - Plug&Play.
                                    Without tons of instruction pages.
                                </p>
                                What is user centric:
                                <ul>
                                    <li>
                                        Always show some empathy to the user and remember that target audience might not
                                        understand
                                        technical details.
                                    </li>
                                    <li>
                                        Provide automations and interfaces with functions of aggregated modifications,
                                        mass update.
                                    </li>
                                </ul>
                                <h4>
                                    Customizable
                                </h4>
                                <p>
                                    Contrary to a hardware, the software has this property that should be easy to change
                                    and adapt to the dynamic environment.
                                </p>
                                We implement customizations by:
                                <ul>
                                    <li>
                                        Exposing public interfaces inside extensions and modules.
                                    </li>
                                    <li>Sticking with SemVer versioning.</li>
                                    <li>
                                        Favoring adapters over 3rd-party API functions.
                                    </li>
                                    <li>
                                        Applying battle-tested architectural patterns.
                                    </li>
                                </ul>
                                <h4>
                                    Innovative
                                </h4>
                                <p>
                                    It is easy to do the same things over and over.
                                    Sometimes it is necessary when the solution works.
                                    However, we owe our ancestors, who lived in harsh times, to embrace the exploratory
                                    spirit.
                                </p>
                                Our innovation is expressed as:
                                <ul>
                                    <li>
                                        We strive to dedicate 30% of our time to research and experimentation.
                                    </li>
                                    <li>
                                        3D web product configurator
                                    </li>
                                    <li>
                                        AR product viewer for Magento 2
                                    </li>
                                    <li>
                                        JAM stack for sustainable blog and websites
                                    </li>
                                    <li>
                                        PWA as alternative to costly native app development
                                    </li>
                                </ul>
                                <h4>
                                    Data-driven
                                </h4>
                                <p>
                                    Bill Gates once wrote: <i>Content is king</i>.
                                    Data must be the Queen then.
                                    Data is a North Star, guiding us on the ocean of possibilities.
                                </p>
                                We stick with data-driven solutions by:
                                <ul>
                                    <li>
                                        Analyzing application performance with APM tools like NewRelic reporting.
                                    </li>
                                    <li>
                                        Logstash monitoring, performance dashboards.
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </PageLayout>
    );
};

export default About;

export const Head = () => <Seo lang="en"
                               meta={meta}
/>;
